module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/6_02e45a5b50848243135bfcb044ff6e6e.png";